import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {updateSidepanelMultiViewFrameHeightsAction} from '../../../../../store/data/localPreferences/localPreferencesActions';
import {MultiViewResizer} from './multiViewResizer';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateSidepanelMultiViewFrameHeights: updateSidepanelMultiViewFrameHeightsAction,
}));

export const MultiViewResizerContainer = connect(null, mapDispatchToProps)(MultiViewResizer);
